import { push } from 'react-router-redux'

import callApi from './apiActions'

export const requestClients = () => {
    return dispatch => {
        dispatch({ type: 'REQUEST_CLIENTS' })

        return dispatch(callApi('get', 'clients'))
            .then(data => {
                dispatch({
                    type: 'REQUEST_CLIENTS_SUCCESS',
                    payload: data.payload
                })
            })
            .catch(err => {
                dispatch({ type: 'REQUEST_CLIENTS_FAIL' })
            })
    }
}

// Chainable, have to .catch errors
export const insertClient = name => {
    return dispatch => {
        return dispatch(callApi('post', 'clients', { name }))
            .then(data => {
                dispatch({
                    type: 'INSERT_CLIENT',
                    payload: data.payload
                })
                dispatch(push(`/admin/asiakkaat/tiedot/${name}`))
            })
            .catch(err => {
                throw err
            })
    }
}

// Chainable, have to .catch errors
export const deleteClient = name => {
    return dispatch => {
        return dispatch(callApi('delete', `clients/${name}`))
            .then(data => {
                dispatch({
                    type: 'DELETE_CLIENT',
                    payload: name
                })
                dispatch(push('/admin/asiakkaat'))
            })
            .catch(err => {
                throw err
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/clientsActions.js